module.exports = __webpack_public_path__ + "static/media/hall_pass.1c7ebacf.svg";